<template>
    <div id="index">
        <!-- 头部 -->
        <HeaderTop :headIndex="head_index" ref="header"></HeaderTop>

        <!-- 推荐内容 -->
        <div class="main wrap flex_between" v-if="!is_list">
            <!-- 推荐 -->
            <div class="recommended">
                <div v-if="!is_form">
                    <div class="recommended_head">
                        <div class="recommended_title flex_start">
                            <span class="tag flex_center">活动</span>
                            {{activity.title}}
                        </div>
                        <div class="head_bottom flex_between">
                            <div class="flex_center head_left">
                                <span class="original"> 活动时间： </span>
                                <span class="time"> {{activity.start_time}}——{{activity.end_time}} </span>
                            </div>
                        </div>
                    </div>
                    <div class="recommended_center" v-html="activity.content">

                    </div>
                    <!-- <div class="center_video" v-if="detail.cover_video">
                                          <video :src="detail.cover_video" preload controls poster></video>
                                      </div> -->
                    <!-- 评论 -->
                    <div class="comments_div"></div>
                    <div class="buttom_div flex_center">
                        <div class="mian flex_center">
                            <button class="activities flex_center" @click="add_form">
                                上传作品
                            </button>
                            <button class="activities_list flex_center" @click="go_showList">
                                作品列表
                            </button>
                        </div>
                    </div>
                </div>
                <!-- 报名表单 -->
                <!-- <activitiesForm v-if="is_form" @shutDownFun="shutDownFun"></activitiesForm> -->
            </div>
            <!-- 热门 -->
            <div class="hot_div hot">
                <div class="hot_title flex_center">
                    <i><img src="@/assets/img/hot.png" alt="" /></i>
                    <span class="flex_center">热门</span>
                </div>
                <div class="">
                    <hot :list="hotList_arr" @detailsFun="detailsFun"></hot>
                </div>
            </div>
        </div>
        <div class="main wrap" v-if="is_list">
            <!-- 报名列表 -->
            <!-- <activitiesList ref='activities_list'  @shutDownFun="shutDownFun" @loginFun='loginFun'></activitiesList> -->
        </div>
        <!-- 尾部 -->
        <Footer></Footer>
    </div>
</template>

<script>
    import activitiesForm from "@/components/pcActivity/activitiesForm.vue"; //报名表单模块
    import activitiesList from "@/components/pcActivity/activitiesList.vue"; //作品列表
    import HeaderTop from "@/components/assembly/HeaderTop.vue"; //头部模块
    import Footer from "@/components/assembly/Footer.vue"; //尾部模块
    import hot from "@/components/assembly/hot.vue"; //热门模块
    import listLi from "@/components/assembly/listLi.vue"; //列表数据模块
    import comments_li from "@/components/assembly/comments_li.vue"; //评论列表数据模块
    import { AnalyticEmotion, Hashtable } from "@/assets/js/pcsinaFaceAndEffec.js";
    import QRCode from "qrcodejs2";

    import "@/assets/js/currency.js";
    import "@/assets/css/reset.css";
    import "@/assets/css/pcsinaFaceAndEffec.css";

    export default {
        name: "index",
        data() {
            return {
                id: 0, //推文id
                hotList_arr: [], //热门，
                head_index: 1, //

                activity: {},
                is_form: false,
                is_list: false,
            };
        },
        computed: {},
        components: {
            HeaderTop,
            Footer,
            hot,
            listLi,
            comments_li,
            activitiesForm,
            activitiesList,

        },
        props: {},
        watch: {},
        methods: {
            loginFun() {//开启登录
                this.$refs.header.promptShow();
            },
            add_form() {
              if (!this.USER() || this.USER().length == 0) {
                    this.loginFun();
                    return false;
                }
                // this.is_form = true;
                this.$router.push({
                    path: "/activitiesForm",
                    query: { id: this.id, head_index: 1 },
                });
            },
            go_showList() {
                // if (!this.USER() || this.USER() == {}) {
                //     this.loginFun();
                //     return false;
                // }
                // this.is_list = true;
                // this.$refs.activities_list.$emit('getList');
                this.$router.push({
                    path: "/activitiesList",
                    query: { id: this.id, head_index: 1 },
                });
            },
            shutDownFun() {
                //返回页面
                this.is_form = false;
                this.is_list = false;
            },
            columnFun() {
                //跳转专栏
                this.$store.commit("setColumn", this.detail.news_conf_id);
                this.$router.replace("/column");
            },
            detailsFun(id) {
                //查看详情
                this.$router.push({
                    path: "/column_details",
                    query: { id: id, head_index: 2 },
                });
            },

            getDetails() {
                //获取详情
                let that = this;
                this.$post("index-view", { id: this.id })
                    .then((res) => {
                        that.activity = res.data;
                    });

            },
            getHotList() {
                //获取热门列表数据
                let that = this;
                this.$post("news_recomm", {
                    type: 4,
                    limit: 10,
                    page: 1,
                }).then((res) => {
                    let data = res.data.data;
                    that.hotList_arr = data;
                });
            },
        },
        created() { },
        mounted() {
            this.head_index = this.$route.query.head_index;
            this.id = this.$route.query.id;
            this.getDetails();
            this.getHotList();
            if (this._isMobile()) {
                // alert("手机端");
                this.$router.push({ path: '/m_activity', query: { id: this.id } });
            } else {
                // alert("pc端");
                // this.$router.replace('/index');
            }
        },
    };
</script>
<style>
</style>
<style scoped>
    .main {
        max-width: 1280px;
        min-width: 865px;
        margin: 0 auto;
        width: 1280px;
        padding: 13px 0;
        align-items: flex-start;
        position: relative;
    }

    #index {
        background: #f5f3fb;
        min-width: 1280px;
        padding-bottom: 80px;
    }

    /* 标题 */
    .recommended {
        width: 795px;
        background: #fff;
        border-radius: 10px;
        padding: 20px 51px;
    }

    .recommended .recommended_head {
        padding: 8px 0;
        border-bottom: 1px solid #999999;
        white-space: normal;
    }

    .recommended .recommended_head .recommended_title {
        font-size: 20px;
        color: #333;
        font-weight: bold;
        margin-bottom: 15px;
    }

    .recommended .recommended_head .recommended_title>.tag {
        border-radius: 4px;
        border: 2px solid #EA6C54;
        color: #EA6C54;
        font-size: 14px;
        margin-right: 10px;
        padding: 0 10px;
        line-height: 24px;
        height: 24px;
    }

    .recommended_head .head_bottom .original {
        font-size: 14px;
        color: #333;
        margin-right: 12px;
    }

    .recommended_head .head_bottom .time {
        font-size: 14px;
        color: #999;
    }

    .recommended_head .head_bottom .head_label {
        margin-left: 10px;
    }

    .recommended_head .head_bottom .head_label .label_li {
        font-size: 14px;
        color: #999;
        margin-left: 30px;
        line-height: 1em;
        cursor: pointer;
        position: relative;
    }

    .recommended_head .head_bottom .head_label .label_li>i {
        width: 15px;
        margin-right: 5px;
    }

    .recommended_head .head_bottom .head_label .label_li .share_div {
        position: absolute;
        bottom: 0;
        display: none;
        left: 50%;
        width: 150px;
        transform: translate(-50%, 110%);
        background: #fff;
        padding: 14px 14px 10px 14px;
        border-radius: 10px;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    }

    .recommended_head .head_bottom .head_label .label_li .share_div::after {
        content: "";
        position: absolute;
        top: 0;
        left: 50%;
        border-top: 10px transparent dashed;
        border-left: 10px transparent dashed;
        border-bottom: 10px transparent dashed;
        border-right: 10px #fff solid;
        transform: translate(-50%, -100%) rotate(90deg);
    }

    .recommended_head .head_bottom .head_label .label_li.share_button:hover .share_div {
        display: block;
    }

    .recommended_head .head_bottom .head_right {
        font-size: 14px;
        color: #333;
        cursor: pointer;
    }

    .wx_saosao {
        margin-top: 6px;
        font-size: 14px;
        color: #858fa6;
    }

    /* 热门 */
    .hot {
        width: 334px;
        background: #fff;
        border-radius: 10px;
        position: absolute;
        /* right: calc((100% - 1280px) / 2); */
        right: 0;
        top: 13px;
    }

    .hot .hot_title {
        border-bottom: 0.005rem solid #999999;
    }

    .hot .hot_title>i {
        width: 15px;
        margin-right: 11px;
    }

    .hot .hot_title>span {
        font-size: 18px;
        font-weight: bold;
        color: #333;
        height: 70px;
    }

    /* 内容 */
    .recommended_center {
        padding: 24px 0;
        line-height: 1.6em;
        font-size: 15px;
        border-bottom: 1px solid #dfdfdf;
    }

    .center_video {
        width: 100%;
    }

    .center_video>video {
        width: 100%;
    }

    /* 评论 */
    .comments_div .comments_input {
        padding: 16px 0;
    }

    .comments_input .inpu_div {
        flex: 1;
        height: 38px;
        border-radius: 4px;
        border: 1px solid #999;
        font-size: 12px;
        margin-right: 17px;
        padding: 0 20px;
    }

    .comments_input .icon_img {
        width: 30px;
        cursor: pointer;
        margin: 0 17px 0 0;
    }

    .comments_input .icon_img.up_img {
        position: relative;
        display: flex;
    }

    .comments_input .icon_img.up_img .inp_img {
        position: absolute;
        top: 0;
        opacity: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        display: inline-block;
        cursor: pointer;
    }

    .comments_input .send {
        width: 81px;
        height: 38px;
        border-radius: 4px;
        background: #f24d5b;
        border: 0;
        font-size: 16px;
        color: #fff;
    }

    .complete {
        padding: 60px 0;
    }

    /* 参与活动列表 */
    .buttom_div {
        /* padding: 100px 0; */
        position: fixed;
        bottom: 0;
        left: 0;
        background: #fff;
        height: 80px;
        right: 0;
        box-shadow: -2px 0 10px rgba(0,0,0,.1);
    }
    .buttom_div>.mian{

    }
    .buttom_div button {
        width: 135px;
        height: 36px;
        line-height: 32px;
        border-radius: 5px;
        background: #fff;
        color: #7f7e7e;
        border: 2px solid #DFDFDF;
        font-size: 15.7px;
        cursor: pointer;
        margin: 0 20px;
    }

    .buttom_div button.activities {
        background: #f24d5b;
        border-color: #f24d5b;
        color: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/components/pcActivity/pc_activity.vue